import React from 'react';
import { Box, Typography } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

/**
 * Tally-style public design layout: hover rail on the left (drag + controls),
 * field content on the right. Presentational only — all state and the built
 * elements (controls, label, body, settings) are owned by WysiwygFieldBlock.
 */
export default function PublicFieldLayout({
  setNodeRef,
  style,
  attributes,
  listeners,
  isDragging,
  showControls,
  palette,
  isDisplayField,
  helpText,
  controlButtons,
  labelEditor,
  fieldBody,
  settingsPanel,
  onMouseEnter,
  onMouseLeave,
}) {
  return (
    <Box
      ref={setNodeRef}
      style={style}
      {...attributes}
      className="form-design-field"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        opacity: isDragging ? 0.5 : 1,
        display: 'flex',
        gap: 0.5,
        py: 1.5,
        px: 0.5,
        borderRadius: '8px',
        transition: 'background-color 120ms ease',
        backgroundColor: showControls ? palette.fieldHoverBg : 'transparent',
      }}
    >
      <Box
        className="form-design-field__rail"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1px',
          pt: 0.5,
          opacity: showControls ? 1 : 0,
          width: showControls ? 28 : 0,
          overflow: 'hidden',
          transition: 'opacity 0.15s ease, width 0.15s ease',
          flexShrink: 0,
        }}
      >
        <Box
          {...listeners}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            cursor: 'grab',
            color: palette.textSecondary,
            '&:active': { cursor: 'grabbing' },
          }}
        >
          <DragIndicatorIcon sx={{ width: 16, height: 16 }} />
        </Box>
        {controlButtons}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        {labelEditor}
        {!isDisplayField && helpText && (
          <Typography sx={{ fontSize: '13px', color: palette.textSecondary, mb: 1, lineHeight: 1.5 }}>
            {helpText}
          </Typography>
        )}
        {fieldBody}
        {settingsPanel}
      </Box>
    </Box>
  );
}
